<!-- loading data layout start -->
@if (loadingData) {
  <div class="loading-screen text-center vh-100 d-flex align-items-center justify-content-center">
    <div>
      <img class="qm-dino-loading-img" src="/assets/images/quote_monster_crunching_animation.gif?v=2" />
      <h3>Loading data.</h3>
    </div>
  </div>
}
<!-- loading data layout end -->

<!-- after loading data layout start -->
@if (loadingData === false) {
  <div class="container-fluid">
    <div id="qmMainTopHeader">
      <nav-menu />
    </div>
    <!-- here is main container start-->
    <div class="qm-h-min-500px">
      <router-outlet />
    </div>
    <!-- here is main container end -->
    <footer id="qmMainBottomFooter" class="row qm-text-white qm-bg-dark-gray qm-py-block footer">
      <div class="container-fluid px-5">
        <div class="row mb-5">
          <!-- social network -->
          <div class="col-lg-6 mb-4 mb-lg-0 text-center text-lg-start">
            <a
              mat-fab
              class="me-3 mb-3 qm-bg-black"
              href="https://www.linkedin.com/company/quality-product-research-ltd"
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer">
              <img width="24" height="24" src="../assets/images/icon/linkedin-white@2x.png?v=2" title="LinkedIn" />
            </a>
            <a
              mat-fab
              class="me-1 me-sm-3 mb-3 qm-bg-black"
              href="https://x.com/QPRQuotemonster"
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer">
              <img width="24" height="24" src="../assets/images/icon/x-logo-white.png" title="x.com" />
            </a>
            <a
              mat-fab
              class="me-0 me-sm-5 mb-3 qm-bg-black"
              href="https://www.youtube.com/channel/UC9gx8xqu7plB7RylVBm-BNg"
              target="_blank"
              rel="noopener"
              referrerpolicy="no-referrer">
              <img width="30" height="30" src="../assets/images/icon/youtube-white.png?v=2" title="Youtube" />
            </a>
            <div class="d-block d-sm-none"></div>
          </div>
          <!-- social network -->
          <!-- logo -->
          <div class="col-lg-6 text-center text-lg-end">
            <img width="257" height="84" src="../assets/images/qpr-footer-logo/qpr-footer-logo@2x.png?v=2" alt="qpr logo" />
          </div>
          <!-- logo -->
        </div>
      </div>
      <!-- copyright & site version & terms-->
      <div class="w-100 border-top border-dark">
        <div class="container-fluid px-5">
          <div class="row">
            <!-- copyright & site version-->
            <div class="pt-5 col-lg-7 text-center text-lg-start">
              <h6 class="qm-text-white text-uppercase">
                Copyright &copy; {{ copyrightYear }} All Rights Reserved by Quality Product Research Limited
              </h6>
              <h6 class="qm-text-white text-uppercase">Quotemonster Internal Group Admin &nbsp;&nbsp;| &nbsp;&nbsp; v.1.0.0</h6>
            </div>
            <!-- copyright & site version end-->
            <!-- terms -->
            <div class="col-lg-5 pt-5 ms-lg-auto text-center text-lg-end">
              <div class="d-flex flex-column justify-content-between h-100">
                <h6 class="text-uppercase">
                  <a class="qm-text-primary" href="/TermsOfUse.html" target="_blank" rel="noopener">Terms of Use & Privacy Policy</a>
                </h6>
                <h6 class="text-uppercase">
                  <a class="qm-text-primary" href="{{ outsourcePASUrl }}" target="_blank" rel="noopener">
                    Outsource Provider Assurance Statement
                  </a>
                </h6>
              </div>
            </div>
            <!-- terms end-->
          </div>
        </div>
      </div>
      <!-- copyright & site version & terms end-->
    </footer>
  </div>
}
<!-- after loading data layout end -->

<!-- SystemNotices start -->
@if (systemNoticesList.length > 0) {
  <div class="alert alert-danger rounded-0 mb-0 py-1 fixed-bottom" [ngClass]="hideSystemNotices ? 'd-none' : 'd-block'">
    <div class="row align-items-center justify-content-center">
      <div class="col-12">
        @for (notice of systemNoticesList; track notice) {
          <p class="mb-0 text-center">
            <strong>{{ notice.Subject }}</strong>
            :
            <span [innerHTML]="notice.Contents"></span>
          </p>
        }
      </div>

      <div class="col-auto">
        <button mat-icon-button class="qm-icon-warn" (click)="hideSystemNotices = !hideSystemNotices">
          <span class="material-icons" aria-label="close">clear</span>
        </button>
      </div>
    </div>
  </div>
}
<!-- SystemNotices end -->
